export default __webpack_public_path__ + "static/media/font.e8ab5688.woff2";